module.exports = __webpack_public_path__ + "static/media/p7.70416ae9.jpg";